import React, { useRef, useState } from 'react';
import { FaArrowRight, FaChevronDown, FaVolumeUp, FaVolumeMute } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import SiteSearch from '../Common/SiteSearch';

const HeroSection = () => {
    const { t } = useTranslation();
    const videoRef = useRef(null);
    const [isMuted, setIsMuted] = useState(true);

    const toggleMute = () => {
        if (videoRef.current) {
            videoRef.current.muted = !isMuted;
            setIsMuted(!isMuted);
            // Ensure video is playing
            videoRef.current.play().catch(err => console.log("Video play error:", err));
        }
    };

    return (
        <section className="relative h-screen overflow-hidden bg-black">
            <video
                ref={videoRef}
                autoPlay
                muted
                loop
                playsInline
                className="absolute inset-0 w-full h-full object-cover"
                style={{ objectPosition: 'center center' }}
                onError={(e) => {
                    // Hide video and show fallback on error
                    if (e.target) e.target.style.display = 'none';
                    const fallback = document.getElementById('video-fallback');
                    if (fallback) fallback.style.display = 'block';
                }}
            >
                <source src="/fenfakultesivideo.mp4" type="video/mp4" />
                Your browser does not support the video tag.
            </video>
            
            <div 
                id="video-fallback"
                className="absolute inset-0 w-full h-full bg-gradient-to-br from-gray-900 to-gray-800 hidden"
            />
            
            <div className="absolute inset-0 bg-black/50" />

            {/* Sound Control Button */}
            <button
                onClick={toggleMute}
                className="absolute bottom-8 right-8 z-20 bg-white/20 hover:bg-white/30 backdrop-blur-md p-4 rounded-full transition-all duration-300 border border-white/40 hover:border-white/60 group"
                aria-label={isMuted ? t('hero.unmute') : t('hero.mute')}
            >
                {isMuted ? (
                    <FaVolumeMute className="w-6 h-6 text-white" />
                ) : (
                    <FaVolumeUp className="w-6 h-6 text-white" />
                )}
            </button>

            <div className="relative z-10 flex items-center justify-center h-full px-6 md:px-24">
                <div className="text-center text-white max-w-3xl w-full animate-fade-in-up">
                    <h1 className="text-4xl md:text-6xl font-extrabold mb-6 leading-tight tracking-tight">
                        {t('hero.universityName')}
                        <br />
                        {t('hero.facultyName')}
                    </h1>

                    {/* Arama kutusu */}
                    <div className="mb-8 mx-auto max-w-xl">
                        <SiteSearch
                            variant="hero"
                            placeholder="Haber, duyuru, sayfa, kişi ara…"
                            className="w-full"
                        />
                    </div>

                    <button
                        onClick={() => window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })}
                        className="inline-flex items-center space-x-3 text-lg font-medium group"
                    >
                        <span className="text-white/80 group-hover:text-white transition-colors border-b border-white/40 group-hover:border-white/80">
                            {t('hero.discoverFaculty')}
                        </span>
                        <FaArrowRight className="w-5 h-5 text-white/80 group-hover:text-white transition-colors" />
                    </button>
                </div>
            </div>
            {/* Animated Scroll Down Indicator */}
            <div
                className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center cursor-pointer group"
                onClick={() => window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })}
            >
                <span className="text-sm font-medium text-white/80 tracking-widest uppercase group-hover:text-white transition-colors duration-300">
                    {t('hero.scrollDown')}
                </span>
                <FaChevronDown className="w-6 h-6 mt-2 text-white animate-bounce" />
            </div>
        </section>
    );
};

export default HeroSection; 